import { jsx as _jsx } from "react/jsx-runtime";
// Мобильный ящик меню — канон preview-platform.jsx: пустая зона клика (не по кнопке) закрывает.
export default function MobileDrawer({ open, onClose, children }) {
    if (!open)
        return null;
    return (_jsx("div", { className: "osn-platform-drawer", role: "dialog", "aria-modal": "true", onClick: (e) => {
            // Пустая зона = клик мимо любой кнопки (пункты/группы/крестик — все button)
            const t = e.target;
            if (t === e.currentTarget || !t.closest("button"))
                onClose();
        }, children: children }));
}
